import React, { useState } from 'react'
import LongPurpleBtn from "./Buttons/LongPurpleBtn"
import XBtn from "./Buttons/XBtn"
import MoreInfo from './MoreInfo'
import {motion} from "framer-motion"
import { useNetworkError } from '../contextAPI/NetworkErrorContext'
const styles = {
    container : {
        position: "absolute",
        height: "100vh",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        zIndex:"9999"
    },
    transDiv: {
       flex:"1",
        opacity: "0.27",
        width: "100%",
        backgroundColor: "#4C2CBF"
    },
    middleDiv:{
     
        width:"100%",
        backgroundColor:"#2c234e",
        display:"flex",
        flexDirection:  "column",
        justifyContent: "space-between",
        alignItems: "center",
        padding:"0 20px"
    },
    confirmationBox: {
        backgroundColor: "#18181A",
        padding: "40px 20px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        alignItems: "center",
        borderRadius: "15px",
        color: "#ffffff",
        border:"1px solid #ff3a3a",
    },
    generalMargin: {
      margin: "10px 0"
    },

   

   
}

const NetworkError= () => {

    const {setHasNetworkError} = useNetworkError()
  return (
    <div style={styles.container}>
      <div style={styles.transDiv}>

      </div>
      <div style={ styles.middleDiv}>
        <motion.div 
        style={styles.confirmationBox}
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.8 }}
        transition={{ duration: 0.3 }}
         
        >
            <h1  style={styles.generalMargin} className='poppins-20px-500'>Network Error</h1>
            <p style={styles.generalMargin} className='poppins-15px-200'>check your network and try agian</p>
           
        </motion.div>
      <motion.div 
       style={{marginTop:"20px"}}
       initial={{ opacity: 0, scale: 0.8 }}
       animate={{ opacity: 1, scale: 1 }}
       exit={{ opacity: 0, scale: 0.8 }}
       transition={{ type: 'spring', stiffness: 500, damping: 25 }}
       >
        <XBtn type="circle" onClick={()=>setHasNetworkError(false)}/>
        </motion.div>
      </div>
      <div  style={styles.transDiv}>

      </div>
    </div>
  )
}

export default NetworkError
